import { render, staticRenderFns } from "./tableIndex.vue?vue&type=template&id=6335f298&scoped=true&"
import script from "./tableIndex.vue?vue&type=script&lang=js&"
export * from "./tableIndex.vue?vue&type=script&lang=js&"
import style0 from "./tableIndex.vue?vue&type=style&index=0&id=6335f298&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6335f298",
  null
  
)

export default component.exports